<template>
    <div class="h-100">
        <div class="pulse-wrapper">
            <div class="pulse pulse-1"></div>
            <div class="pulse pulse-2"></div>
            <div class="pulse pulse-3"></div>  
        </div>
        <span>
            <img src="@/assets/images/menuicon.png" alt="">
        </span>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
span{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background:#fff;
    border-radius: 50%;
}
</style>